import { defaultOasisProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/oasis/default-constants';

export const YUZU_SWAP_CONTRACT_ADDRESS = '0x250d48C5E78f1E85F7AB07FEC61E93ba703aE668';

export const YUZU_SWAP_PROVIDER_CONFIGURATION = defaultOasisProviderConfiguration;
